import DiscountLogo from "../../assets/discountLogo.jsx";

const bannerData = {
  title: "Welcome to AutoCare",
  description: "Your one-stop solution for all car care needs!",
  image: DiscountLogo,
};

function Banner({ username = "" }: { username: string }) {
  return (
    <div className="banner p-4 rounded-lg shadow-[0_-6px_10px_-2px_rgba(0,0,0,0.2),_0_6px_10px_-2px_rgba(0,0,0,0.2)] bg-secondaryBg dark:bg-secondaryBgDark flex justify-between items-center">
      <div className="w-3/5">
        <h1 className="font-bold text-3xl text-secondaryText dark:text-secondaryTextDark mb-2">
          {(username ? `Hey ${username.trim().split(" ")[0]}, ` : "") +
            bannerData.title.toUpperCase()}
        </h1>
        <p className="text-primaryText dark:text-primaryTextDark">
          {bannerData.description}
        </p>
      </div>
      <div className="w-2/5">
        <bannerData.image />
      </div>
    </div>
  );
}

export default Banner;
